<template>
  <ITMPage>
    <div class="container">
      <div class="spcore-box right-box">
        <div class="hvh-flex align-center">
          <h2 class="report-heading">FedEx Tracking</h2>
        </div>
        <div class="hvh-flex align-center">
          <input v-model="trackingNumber" type="text" class="tracking-input" placeholder="Enter Tracking Number" />
          <button @click="submitTracking" class="submit-btn">Submit</button>
        </div>
        <div v-if="statusMessage" class="status-label">{{ statusMessage }}</div>
      </div>
    </div>
  </ITMPage>
</template>

<script>
import ITMPage from '../../components/itm/ITMPage.vue'

export default {
  components: { ITMPage },
  data() {
    return {

      isLoading: false,
      trackingNumber: '',
      statusMessage: '',

    };
  },
  computed: {
  },
  methods: {
    submitTracking() {
      if (this.trackingNumber.trim() !== '') {
        this.statusMessage = 'Unfortunately we are unable to retrieve your tracking results at this time. Please try again later.';
      } else {
        alert('Please enter a valid tracking number.');
      }
    },


  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMFedexSearch'] = this;

  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.spcore-box {
  width: 45%; /* Adjust as needed */
  height: 500px; /* Adjust as needed */
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.report-heading {
  font-weight: normal; /* Reset font-weight to normal */
}

.left-box {
  margin-right: 20px;
}

.right-box {
  margin-left: 20px;
}

.hvh-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tracking-input {
  width: 75%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  background-color: green;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.status-label {
  margin-top: 10px;
  font-weight: bold;
  color: red;
}
</style>